import { INJECT_VIDEO_LOGO, InjectVideoLogoParams } from '../../navigation.actions';
import { NavigationLink, SvgLink, Svg } from '../../navigation.utils';

type Link = {
  text: string;
  href: string;
};

export interface SubHeader {
  logoForLargeScreen: SvgLink | null;
  logoForSmallScreen: SvgLink| null;
  links: NavigationLink[];
  socialSection: SvgLink[] | null;
  moreButtonText: string;
}

export interface HeaderState {
  logo: SvgLink;
  links: NavigationLink[];
  editions: NavigationLink[] | null;
  editionsIcon: Svg | null;
  videoLogo?: InjectVideoLogoParams;
  socialSection: SvgLink[] | null;
  moreButtonText: string;
  subHeader: SubHeader | null;
  cta: Link | null;
}

export interface InjectVideoLogoAction {
  type: typeof INJECT_VIDEO_LOGO;
  videoPath: string;
}

export type HeaderAction = InjectVideoLogoAction;
export const headerReducer = (state: HeaderState = {} as HeaderState, action: HeaderAction) => {
  switch (action.type) {
    case INJECT_VIDEO_LOGO: {
      const { videoPath } = action;
      return {
        ...state,
        videoLogo: {
          videoPath,
        },
      };
    }
    default:
      return state;
  }
};
